import classes from './style/nav.module.css'
import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import { NavHashLink } from 'react-router-hash-link';

const Nav = () => {
    const [active, setActive] = useState("sleepOptions")
    const navHandeler = () => {
        setActive('optionsActive')
    }

    const closeNav = () => {
        setActive('sleepOptions');
    }
    return (
        <div className={classes.fix}>
            <div className={classes.nav}>
                <div className={classes.logoContainer}>
                    <h1>//Yosef Adel</h1>
                </div>

                {
                    <div className={classes.navOptions}>
                        <div className={`${classes[active]} ${classes.options}`}>
                            <ul className={classes.links}>
                                <li onClick={closeNav} className={classes.op}>

                                    <NavHashLink to="/#layout"  >  Home  </NavHashLink>

                                </li>
                                <li onClick={closeNav} className={classes.op}>
                                    <NavHashLink to="/#skills">Skills</NavHashLink>
                                </li>
                                <li onClick={closeNav} className={classes.op}>
                                    <NavHashLink to="/#services"> Services</NavHashLink>
                                </li>
                                <li onClick={closeNav} className={classes.op}>
                                    <NavHashLink to="/#work" >Portfolio</NavHashLink>
                                </li>
                                <li onClick={closeNav} className={classes.op}>
                                    <NavHashLink to="/#contact" >contact</NavHashLink>

                                </li>
                            </ul>
                        </div>

                    </div>
                }

                {active === 'sleepOptions' ? false : <div className={classes.back} onClick={closeNav}></div>}
                <div className={classes.bur} >
                    {active === 'sleepOptions' ? <MenuIcon onClick={navHandeler} style={{ fontSize: 40 }} /> : <ClearIcon onClick={closeNav} style={{ fontSize: 40 }} />}
                </div>

            </div>

        </div>
    )
}

export default Nav
